import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  createConversation,
  deleteConversation,
  updateConversation,
} from "./ToddleDocMutations";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { transformConversation, transformConversationForUpdate } from "./utils";
import { getToddleDocAttachmentQuery } from "./ToddleDocQuery";
import { downloadFromUrl } from "modules/Services";
import { getPrintFile } from "modules/PrintThunks";
import moment from "moment";

export const createToddleDocConversation = (
  toddleDocId,
  conversations,
  config
) => {
  return async (dispatch, getState) => {
    try {
      // Transform all conversations
      const addedToddleDocConversations = _.isArray(conversations)
        ? _.map(conversations, transformConversation, config)
        : [transformConversation(conversations, config)];

      const response = await client.mutate({
        mutation: createConversation,
        variables: {
          input: {
            toddleDocId,
            addedToddleDocConversations,
          },
        },
      });
      return _.get(
        response,
        "data.platform.createToddleDocConversation.conversations.[0]"
      );
    } catch (e) {
      if (_.get(e, "networkError")) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateToddleDocConversation = (
  oldConversation,
  newConversation,
  config = {}
) => {
  return async (dispatch, getState) => {
    try {
      // Match conversations by id/internalThreadId
      const input = [
        transformConversationForUpdate(
          oldConversation || {},
          newConversation,
          config
        ),
      ];

      const updatedResponse = await client.mutate({
        mutation: updateConversation,
        variables: {
          input,
        },
      });
      return _.get(
        updatedResponse,
        "data.platform.updateToddleDocConversation.conversations.[0]"
      );
    } catch (e) {
      if (_.get(e, "networkError")) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteToddleDocConversation = threadId => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteConversation,
        variables: {
          input: {
            ids: [threadId],
          },
        },
      });
    } catch (e) {
      if (_.get(e, "networkError")) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const getToddleDocAttachment = variables => {
  return async dispatch => {
    try {
      const response = await client.query({
        query: getToddleDocAttachmentQuery,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      if (e) dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const downloadToddleDoc = ({
  attachment,
  shouldAskForSave = false,
  showProgress = true,
  name,
  headers,
  parentType,
  parentId,
  includeComments = false,
} = {}) => {
  return async (dispatch, getState) => {
    try {
      const fileId = _.get(attachment, "attachmentId", _.get(attachment, "id"));
      const fileName =
        name ||
        _.get(attachment, "name", "") ||
        `toddle_doc_${moment().format("DD-MM-YY_h_mm")}`;
      const metadata = _.get(attachment, "metadata", {}) || {};

      const fileUrl = await dispatch(
        getPrintFile({
          id: fileId,
          mode: "pdfurl",
          name: fileName,
          type: "toddleDoc",
          metadata: { ...metadata, includeComments },
          shouldOpenInWindow: false,
          isDownload: false,
        })
      );
      if (!fileUrl) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return null;
      }

      const downloadAttachment = { ...attachment, url: fileUrl };

      return await dispatch(
        downloadFromUrl({
          downloadUrl: fileUrl,
          attachment: downloadAttachment,
          shouldAskForSave,
          showProgress,
          headers,
          parentType,
          parentId,
        })
      );
    } catch (e) {
      if (_.get(e, "networkError")) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      return null;
    }
  };
};
